import type { SignalProbabilityRow } from '../../api/signalOps';

/** Below this many accounts a lift is too noisy to colour as good or bad. */
export const MIN_LIFT_N = 10;

/**
 * Green or red only when the evidence says so: enough accounts, at least one
 * conversion, and a credible interval that excludes the base rate (a lift of
 * 1). A 0-of-14 signal at 0.63× is "no evidence yet", not a bad signal (review #11).
 */
export function liftVerdict(
  r: Pick<SignalProbabilityRow, 'accountsWithSignal' | 'convertedWithSignal' | 'credibleLow' | 'credibleHigh' | 'liftRatio'>,
  baseRate: number,
): { tone: 'good' | 'bad' | 'neutral'; why: string | null } {
  if (r.accountsWithSignal < MIN_LIFT_N) return { tone: 'neutral', why: `Only ${r.accountsWithSignal} accounts: too few to call` };
  if (r.convertedWithSignal === 0) return { tone: 'neutral', why: 'No account with this signal has converted yet: no evidence either way' };
  if (r.credibleLow <= baseRate && baseRate <= r.credibleHigh) {
    return { tone: 'neutral', why: 'The 94% interval includes the base rate: not distinguishable from no lift' };
  }
  return { tone: r.liftRatio > 1 ? 'good' : 'bad', why: null };
}

